import i18n from "@i18n";

const { t } = i18n;

export const excludedColumns = [
  {
    field: "properties.Quantity",
    isFrozen: false,
    allowReordering: false,
    width: 150,
    headerText: t("Quantity"),
    allowGrouping: false,
  },
  {
    field: "properties.Unit",
    isFrozen: false,
    allowReordering: false,
    width: 150,
    headerText: t("Unit"),
    allowGrouping: false,
  },
];

export const compulsoryColumns = [
  {
    field: "checkbox",
    type: "checkbox",
    allowSorting: false,
    allowFiltering: false,
    width: 35,
  },
  {
    field: "actions",
    headerText: t("Actions"),
    width: 110,
    allowReordering: false,
    allowGrouping: false,
  },
  {
    field: "nodeId",
    headerText: t("CUBE ID"),
    width: 110,
    allowReordering: false,
    allowGrouping: false,
  },
  {
    field: "properties.CUBE Name",
    headerText: t("CUBE Name"),
    width: 150,
    allowReordering: false,
    allowGrouping: false,
  },
];
